export default __webpack_public_path__ + "static/media/d_video.b63bab9f.png";